export default __webpack_public_path__ + "static/media/ic_usdt_40.e357d24a.svg";